(() => {
  const drawer = document.querySelector('cart-drawer.lma-cart-drawer');
  if (!drawer) return;

  const durationMs = 298000; // 4:58, starting on each cart opening.
  let deadline = 0;
  let intervalId = 0;
  let wasOpen = false;

  function updateCountdown() {
    const notice = drawer.querySelector('[data-lvn-cart-offer-timer]');
    const clock = notice?.querySelector('[data-lvn-cart-countdown]');
    if (!notice || !clock || !deadline) return;

    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    notice.hidden = seconds === 0;
    if (seconds === 0) return;

    const minutes = Math.floor(seconds / 60);
    const remainder = seconds % 60;
    const label = `${String(minutes).padStart(2, '0')}:${String(remainder).padStart(2, '0')}`;
    if (clock.textContent !== label) clock.textContent = label;
  }

  function syncDrawerState() {
    const isOpen = drawer.classList.contains('active');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

    window.clearInterval(intervalId);
    intervalId = 0;
    if (!isOpen) {
      deadline = 0;
      return;
    }

    deadline = Date.now() + durationMs;
    updateCountdown();
    intervalId = window.setInterval(updateCountdown, 500);
  }

  new MutationObserver(syncDrawerState).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
  });
  syncDrawerState();
})();
